import { recommendationTypes } from './ExchangeRecommendationTypeSelector/constants'

export const getPayload = ({
  productVariantExchangeRecommendationType,
  productVariantExchangeRecommendationValue,
  productVariantExchangeTaxonomyType,
  productVariantExchangeTaxonomyDisplay,
  productVariantExchangeTaxonomyIds,
  customerContactMethod,
  allowsOrderRecovery,
  skipSingleRefundMethodStep,
}) => {
  return {
    product_variant_exchange_recommendation_type: productVariantExchangeRecommendationType,
    product_variant_exchange_recommendation_value:
      productVariantExchangeRecommendationType === recommendationTypes.automatic
        ? ''
        : productVariantExchangeRecommendationValue,
    product_variant_exchange_taxonomy_type: productVariantExchangeTaxonomyType,
    product_variant_exchange_taxonomy_display: productVariantExchangeTaxonomyDisplay,
    product_variant_exchange_taxonomy_ids: productVariantExchangeTaxonomyIds,
    contact_method: customerContactMethod,
    allows_order_recovery: allowsOrderRecovery,
    skip_single_refund_method_step: skipSingleRefundMethodStep,
  }
}
